import React from 'react'
import { Redirect } from 'react-router-dom'

export const Top = () => <Redirect to="/surveys" />
